module.exports = __webpack_public_path__ + "static/pr-op-packing@3x-90bc2b5e5141efb4961141301d816302.png";